import React from 'react';
import PropTypes from 'prop-types';
import { domToReact, attributesToProps } from 'html-react-parser';
import SourceIdLink from '../../../../../components/Molecules/SourceIdLink';

const withCtaLink = (location) => 
{
    const Wrapper = ({ name = '', type = '', attribs = { href: '' }, children = null }) => 
    {
        if (type !== 'tag') return null;
        if (!name || name !== 'a') return null;
        if (!attribs?.href) return null;
        if (!attribs.href.includes('#sourceid')) return null;

        const childComponents = domToReact(children);
        const props = attributesToProps(attribs);
        props['data-pathname'] = location?.pathname;

        return <SourceIdLink {...props}>{childComponents}</SourceIdLink>;
    };

    Wrapper.propTypes = {
        name: PropTypes.oneOf(['a']),
        type: PropTypes.oneOf(['tag']),
        attribs: PropTypes.shape({
            href: PropTypes.string
        }),
        children: PropTypes.node,
    }

    return Wrapper;
};

export default withCtaLink;
